import { queryUserProfile } from 'src/gql/queries/queryUserProfile'

export const profileServices = {
  getProfile: queryUserProfile,
}

export type ProfileServices = typeof profileServices
